<template>
  <div class="CollectionRecommend">
    <CollectionListHeader
      :more-link="moreLink"
      :topicTitle="topicTitle"
    >
      <i
        slot="icon"
        class="icon_subscription"/>
    </CollectionListHeader>


    <div class="inner_center">
      <PicList
        :isShowPicTitle="true"
        v-bind="$attrs"
        v-on="$listeners"/>
    </div>

  </div>
</template>

<script>
import CollectionListHeader from '@/components/collection/collection-list/conllection-list-header'
import PicList from '@/components/pic/pic-list/pic-list';

import {PAGE_PATH} from '@/constant/PAGE_PATH'
import {mapState} from "vuex";

export default {
  name: "CollectionRecommend",
  components: {
    CollectionListHeader,
    PicList,
  },
  props: {
    topicTitle: {
      type: String,
      default: ""
    },
  },
  computed: {
    ...mapState('base', ['spider', '']),
  },
  data() {
    return {
      moreLink: PAGE_PATH.TOPIC.DEFAULT
    }
  }
}
</script>

<style lang="scss" scoped>
.CollectionRecommend {
  background: #F5F6FA;
  padding: 48px 0 35px;

  .icon_subscription {
    @include BgImage(28px, 28px, 'topic/index/icon_subscription.svg');
    margin-right: 14px;
  }

  .inner_center {
    //width: 1200px !important;
  }
}
</style>
